<template>

  <div id="app">

<!--
      ------------------------------Home Page---------------------------
      Rev 01.02 del 07/05/2024

<b-container fluid="auto" >
    <b-row class="mb-20">
        <b-col  class="p-6  text-white mr-2" >
         <img alt="Vue logo" :src= "require(`@/assets/${Header_Page}.png`)">
      </b-col >
        <b-col  class="p-0  text-white" >
          <a href="javascript:;" v-on:click="openGlossario()" >
             <img
             :src="require(`@/assets/News.png`)" 
             alt="Avio"
             align="right"
             responsive="true"
             TARGET="_blank">
          </a>
      </b-col>
    </b-row>
</b-container>


-->




    <component-to-re-render :key="componentKey" />
    <header class="header">
     <img alt="Vue logo" :src= "require(`@/assets/${Header_Page}.png`)">
   </header>

   <div class="tile is-ancestor">
    <div class="tile is-parent">
      <article class="tile is-child box notification is-primary is-success">

        <p class="subtitle">{{currentDate()}}</p>
      </article>
    </div>


<!--

    <div class="tile is-parent">

      <article class="tile is-child box notification is-primary is-success">
        <a href="javascript:;" v-on:click="openNews()" >
           <img
           :src="require(`@/assets/News.png`)" 
           alt="Avio"
           align="center"
           responsive="true"
           TARGET="_blank">
        </a>
      </article>

    </div>

-->


  </div>

   <div class="tile is-ancestor">
    <div class="tile is-parent">
      <article class="tile is-child box notification is-primary is-info">

       <a href="javascript:;" v-on:click="openATIS()" >
         <img
         :src="require(`@/assets/${Sfondo_ATIS}.jpg`)" 
         alt="ATIS"
         responsive="true"
         TARGET="_blank">
       </a>
       <a href="javascript:;" v-on:click="openAvio()" >
         <img
         :src="require(`@/assets/${Sfondo_Avio}.jpg`)" 
         alt="Avio"
         responsive="true"
         TARGET="_blank">
       </a>
       <p class="title">{{gettextnew('Climavia Avio')}}</p>


      </article>
    </div>
    <div class="tile is-parent">
      <article class="tile is-child box notification is-primary is-info">

       <a href="javascript:;" v-on:click="openUrbano()" >
         <img
         :src="require(`@/assets/${Sfondo_Urbano}.jpg`)" 
         alt="Urbano"
         responsive="true"
         TARGET="_blank">

       <p class="title">{{gettextnew('Climavia Urbano')}}</p>

       </a>

      </article>
    </div>
    <div class="tile is-parent">
      <article class="tile is-child box notification is-primary is-info">


       <a href="javascript:;" v-on:click="openMMIS()" >
         <img
         :src="require(`@/assets/${Sfondo_MMIS}.jpg`)" 
         alt="MMIS"
         responsive="true"
         TARGET="_blank">
       </a>
       <a href="javascript:;" v-on:click="openNautico()" >
         <img
         :src="require(`@/assets/${Sfondo_Nautico}.jpg`)" 
         alt="Nautico"
         responsive="true"
         TARGET="_blank">
       </a>

       <p class="title">{{gettextnew('Climavia Nautica')}}</p>



      </article>
    </div>
    </div>

   <div class="tile is-ancestor">

    <div class="tile is-parent">
      <article class="tile is-child box notification is-primary is-info">

       <a href="javascript:;" v-on:click="openGlossario()" >

       <p class="subtitle"><i>{{gettextnew('Glossario di Meteorologia Aeronautica')}}</i></p>

       </a>

      </article>
    </div>

    <div class="tile is-parent">
      <article class="tile is-child box notification is-primary is-info">

       <a href="javascript:;" v-on:click="openArchitettura()" >

       <p class="subtitle"><i>{{gettextnew('Architettura Climavia')}}</i></p>

       </a>

      </article>
    </div>

    <div class="tile is-parent">
      <article class="tile is-child box notification is-primary is-info">

       <a href="javascript:;" v-on:click="openGlossarioMarina()" >

       <p class="subtitle"><i>{{gettextnew('Glossario di Meteorologia Marittima')}}</i></p>

       </a>

      </article>
    </div>



  </div>






<component-to-re-render :key="componentKey" />

<!--
<div class="tile " >
  <div class="tile is-vertical  is-4">

  <article class="tile is-child box notification is-success">
    <div class="content">
      <p class="title">Situazione Meteorologica</p>
      <a href="javascript:;" onClick="window.open('https://www.climavia.city/Images/Metar_Legenda2.pdf', 'Legenda', 'width=1000, height=600, resizable, status, scrollbars=1, location');">
       <img
       :src="Carta" onerror="this.src='https://www.climavia.city/Images/loading.png';"
       alt="Carta Meteorologica"
       responsive="true"
       TARGET="_blank" >
     </a>


   </div>
 </article>
</div>
</div>
-->
<footer class="footer">
  <div class="content has-text-left">
      <p><B><u>Disclaimer Copyright: </u></B><i>Tutti i contenuti di questo sito web sono proprietà esclusiva e riservata del titolare e/o dei suoi aventi causa e/o di terzi soggetti ove indicati, e sono protetti dalle vigenti norme nazionali ed internazionali in materia di tutela dei diritti di Proprietà Intellettuale e/o Industriale.<br>
      <B><u>Sono vietati </u></B>il prelievo, la diffusione e l'utilizzo a fini pubblicitari e/o commerciali e l'utilizzo, anche parziale, per la realizzazione di altri siti Internet.</i></p> 
  </div>
  <div class="content has-text-centered">
    <p>
      <p>&copy; Climavia contacts:<br>
        <a href="mailto:valerio.ferraguto@sistemifutura.it">
          <strong>Valerio Ferraguto</strong><br></a>
          <a href="mailto:giuseppe.zampatti@sistemifutura.it"> <strong>Giuseppe Zampatti</strong><br></a> 
          <a href="mailto:giancarlo.ruggeri@sistemifutura.it"> <strong>Giancarlo Ruggeri</strong><br></a> 
        </p>
        <p> Copyright © Sistemi Futura S.r.l. - All Rights Reserved </p>
        <p> P.iva 01300551007 - C. F. 04771120583 </p>

  </div>
    </footer>
</div>
</template>

<script>
//  import DefChart from './components/DefChart.vue'


import Vue from 'vue'
import Buefy from 'buefy'
import axios from 'axios';
//import VueThermometer from 'vuejs-thermometer';
//import Skycon from "vue-skycons";
//import VueYouTubeEmbed from 'vue-youtube-embed'



Vue.use(Buefy)
//Vue.use(VueYouTubeEmbed)
Vue.config.productionTip = false
export default {
  name: 'App',

  components: {
//    DefChart,
//  VueThermometer,
//  Skycon
//   Users

},
data() {return {
  users: null,

  Home_News:null,
  Home_Avio:null,
  Home_ATIS:null,
  Home_MMIS:null,
  Home_Urbano:null,
  Home_Nautico:null,
  Home_Architettura:null,
  Home_Glossario:null,
  Home_GlossarioMarina:null,
  Sfondo_Avio:null,
  Sfondo_ATIS:null,
  Sfondo_Nautico:null, 
  Sfondo_MMIS:null,
  Sfondo_Urbano:null,
  componentKey: 1,
  lingua:this.getNavigatorLanguage(),

//INIZIO 24/04/2024
  term:null,
  country:null,
  region:null,
  responseIp:null,
  urlIP:null,
//  sql:null,
//  esito:null,
  flag:0,
//FINE 24/04/2024
  
  Carta:null,
  Header_Page:null}
  ;},

  mounted() {
      window.onresize = () => {
          this.windowWidth = window.innerWidth
      }
  },


  created: function() {

   this.interval = setInterval(() =>{
                this.reRender();
            }, 3000);



   this.$once("hook:beforeDestroy", () => {
    clearInterval(this.interval);
  });

   this.getAll();
   this.LoadLanguage();


//INIZIO 24/04/2024
   this.showYourIp();
//FINE 24/04/2024

//   this.Home_Avio= "https://www.climavia.city/home_avio.php";
//   this.Home_Urbano= "https://www.climavia.city/home_urbano.php";
//   this.Home_Nautico= "https://www.climavia.city/home_nautico.php";
   this.Home_News= "https://www.climavia.city/CLIMAVIA_Istruzioni Servizio_Messaggistica_Stato_Siti.pdf?updated=" + this.componentKey;
   this.Home_Avio= "https://www.climavia.city/index_avio_xSite.php";
   this.Home_MMIS= "https://www.climavia.city/index_nautico_xSite_MMIS.php";
   this.Home_ATIS= "https://www.climavia.city/index_avio_xSite_ATIS.php";
   this.Home_Urbano= "https://www.climavia.city/index_urbano_xSite.php";
   this.Home_Nautico= "https://www.climavia.city/index_nautico_xSite.php";
   this.Home_Architettura = "https://www.climavia.city/Climavia_Background.png?updated=" + this.componentKey;
   this.Home_Glossario = "https://www.climavia.city/Glossario Meteorologia Aeronautica.pdf?updated=" + this.componentKey;
   this.Home_GlossarioMarina = "https://www.climavia.city/Glossario Meteorologia Marittima.pdf?updated=" + this.componentKey;
   this.Sfondo_Avio= "Sfondo_Avio";
   this.Sfondo_ATIS= "Sfondo_ATIS";
   this.Sfondo_Nautico= "Sfondo_Nautico";
   this.Sfondo_MMIS= "Sfondo_Nautico_MMIS";
   this.Sfondo_Urbano= "Sfondo_Urbano";

   this.Carta= "https://www.climavia.city/CLIMAVIA_Ali_Nettuno/snapshot/carta/99_image_30.gif?updated=" + this.componentKey;

   this.Header_Page= this.gettextnew("CLIMAVIA_Home");





  },

  methods: {


//INIZIO 24/04/2024
    showYourIp() {
      fetch('https://ipapi.co/json/')
      .then(x => x.json())
      .then(({ ip, country_name, region }) => {
          this.term = ip;
          this.country = country_name;
          this.region = region;
          this.urlIP='https://www.climavia.city/IP.php?IoT=Home_Page_xSite' + '&IP='+this.term+ '&REGION='+this.region+'&COUNTRY='+this.country;
          if (this.flag == 0){
            this.flag= 1;
            this.SendIp(this.urlIP)
          }
      });
    },


    SendIp(urlIP) {
//      var esito;
//      var sql;
      fetch(urlIP)
      .then(response => response.json())
//      .then(({ sql, Esito }) => {
//          sql = sql;
//          esito = Esito;
//      });
     },

//FINE 24/04/2024


    LoadLanguage() {
      axios
        .get("../language/climavia.json")
        .then(response => {
          this.language = response.data;
        });
     },



    getAll(){
      axios
      .get('https://www.climavia.city/WW_IoT_Pegaso_Query_New.php?IoT=CLIMAVIA_Ali_Nettuno'
        )
      .then(res => {
        this.users = res.data;
        this.lingua = this.getNavigatorLanguage()





})
      .catch(function (error,req){console.log(req);
        console.log(error);})



    },


    currentDate() {
      const options = {'day': '2-digit', 'month': 'long', 'year': 'numeric', 'hour12': false};
      options.timeZone = 'Europe/Rome';
      //navigator.language tiene conto della lingua impostata dal browser
      return new Date().toLocaleTimeString(navigator.language, options).replace(/(.*)\D\d+/, '$1');




    },
    getTwentyFourHourTime(amPmString) { 
      const options = {'hour': '2-digit', 'minute': '2-digit', 'hour12': false};
      options.timeZone = 'Europe/Rome';
      return new Date("1/1/2013 " + amPmString + '-0100').toLocaleTimeString(navigator.language, options);
    },





    gettextnew(text) { 


      if (this.language.[this.lingua].[text]) {
        return this.language.[this.lingua].[text];
      }
      else {
        return text;
      }

    },


    getNavigatorLanguage() { 
      return navigator.language.substring(0,2);
    },


    myFunction() {
      this.reRender();
    },



    openNews(){
      window.open(this.Home_News, "_blank");
    },
    openAvio(){
      window.open(this.Home_Avio, "_self");
    },
    openMMIS(){
      window.open(this.Home_MMIS, "_self");
    },
    openATIS(){
      window.open(this.Home_ATIS, "_self");
    },
    openUrbano(){
      window.open(this.Home_Urbano, "_self");
    },
    openNautico(){
      window.open(this.Home_Nautico, "_self");
    },
    openArchitettura(){
      window.open(this.Home_Architettura, "_blank width=1000, height=600, resizable, status, scrollbars=1, location");
    },
    openGlossario(){
      window.open(this.Home_Glossario, "_blank width=1000, height=600, resizable, status, scrollbars=1, location");
    },
    openGlossarioMarina(){
      window.open(this.Home_GlossarioMarina, "_blank width=1000, height=600, resizable, status, scrollbars=1, location");
    },





    reRender(){
      this.$forceUpdate();
      this.componentKey += 1;
      this.getAll();

//   this.Home_Avio= "https://www.climavia.city/home_avio.php";
//   this.Home_Urbano= "https://www.climavia.city/home_urbano.php";
//   this.Home_Nautico= "https://www.climavia.city/home_nautico.php";
   this.Home_News= "https://www.climavia.city/CLIMAVIA_Istruzioni Servizio_Messaggistica_Stato_Siti.pdf?updated=" + this.componentKey;
   this.Home_Avio= "https://www.climavia.city/index_avio_xSite.php";
   this.Home_Urbano= "https://www.climavia.city/index_urbano_xSite.php";
   this.Home_Nautico= "https://www.climavia.city/index_nautico_xSite.php";
      this.Home_Architettura = "https://www.climavia.city/Climavia_Background.png?updated=" + this.componentKey;
      this.Home_Glossario = "https://www.climavia.city/Glossario Meteorologia Aeronautica.pdf?updated=" + this.componentKey;
       this.Home_GlossarioMarina = "https://www.climavia.city/Glossario Meteorologia Marittima.pdf?updated=" + this.componentKey;
       this.Sfondo_Avio= "Sfondo_Avio";
       this.Sfondo_ATIS= "Sfondo_ATIS";
       this.Sfondo_Nautico= "Sfondo_Nautico";
       this.Sfondo_MMIS= "Sfondo_Nautico_MMIS";
       this.Sfondo_Urbano= "Sfondo_Urbano";

       this.Carta= "https://www.climavia.city/CLIMAVIA_Ali_Nettuno/snapshot/carta/99_image_30.gif?updated=" + this.componentKey;

     this.Header_Page= this.gettextnew("CLIMAVIA_Home");




    },



  },


  computed:{
    getArray(){
      const arr = this.users.filter((item , index)=>{
                       return index > 8; //will return the array from the second value
                     })
      return arr;
    }
  }





}


</script>



<style>

  #app {
   font-family: Avenir, Helvetica, Arial, sans-serif;
   -webkit-font-smoothing: antialiased;
   -moz-osx-font-smoothing: grayscale;
   text-align: center;
   color: #2c3e50;
   margin-top: 60px;
 }

</style>
<style scoped lang="scss">
  @import "~bulma/sass/utilities/_all";
  //$footer-background-color: $turquoise;
  $footer-color:true;
  // Import Bulma and Buefy styles
  @import "~bulma";
  @import "~buefy/src/scss/buefy";

</style>
